import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const ClassificationFilter = ({
  filters,
  actions,
}: FilterItemsProps) => {
  return (
    <FilterListContainer id="classification-filter">
      <FilterCheckbox
        id="Urgent"
        label={t("classification.urgent")}
        checked={isChecked(filters.classification, "Urgent")}
        onCheckFilter={actions.setClassification}
        value="urgent"
      />
      <FilterCheckbox
        id="High"
        label={t("classification.high")}
        checked={isChecked(filters.classification, "High")}
        onCheckFilter={actions.setClassification}
        value="high"
      />
      <FilterCheckbox
        id="Medium"
        label={t("classification.medium")}
        checked={isChecked(filters.classification, "Medium")}
        onCheckFilter={actions.setClassification}
        value="medium"
      />
      <FilterCheckbox
        id="Low"
        label={t("classification.low")}
        checked={isChecked(filters.classification, "Low")}
        onCheckFilter={actions.setClassification}
        value="low"
      />
    </FilterListContainer>
  );
};
